export default __webpack_public_path__ + "static/media/image-zx9.89573543.jpg";